import { call, put } from 'redux-saga/effects';
import { EnterpriseDocStoreService, ErrorMessageConstants } from "../../common";
import { deleteAttachmentsFailureAction } from '../actions';
export const deleteAttachmentsSaga = function* (action, 
/*istanbul ignore next*/
enterpriseDocStoreService = new EnterpriseDocStoreService()
/*istanbul ignore next*/
) {
    const deletedAttachmentIds = [];
    let hasDeleteAttachmentsFailure = false;
    for (const attachment of action.payload.attachments) {
        try {
            if (attachment.referenceDocUuid) {
                yield call({ context: enterpriseDocStoreService, fn: enterpriseDocStoreService.deleteFile }, attachment.referenceDocUuid);
                deletedAttachmentIds.push(attachment.id);
            }
        }
        catch (e) {
            hasDeleteAttachmentsFailure = true;
        }
    }
    if (hasDeleteAttachmentsFailure) {
        yield put(deleteAttachmentsFailureAction(ErrorMessageConstants.GENERIC_ERROR_MESSAGE));
        throw new Error(ErrorMessageConstants.GENERIC_ERROR_MESSAGE);
    }
};
//# sourceMappingURL=deleteAttachmentsSaga.js.map